import add from 'date-fns/add';
import format from 'date-fns/format';
import isToday from 'date-fns/isToday';
import React, { useState } from 'react';

import { Button, Icon, Stack } from '@eluve/components';

export interface DateNavigatorProps {
  startingDate?: Date;
  onDateChanged?: (newDate: Date) => void;
}

export const DateNavigator: React.FC<DateNavigatorProps> = ({
  onDateChanged,
  startingDate,
}) => {
  const [date, setDate] = useState(startingDate ?? new Date());

  const changeDate = (newDate: Date) => {
    setDate(newDate);
    onDateChanged?.(newDate);
  };

  const changeDay = (days: number) => {
    const newDate = add(date, { days });
    changeDate(newDate);
  };

  return (
    <Stack
      className="flex-1 sm:flex-nowrap"
      direction="horizontal"
      gap={2}
      wrap
    >
      <Button
        onClick={() => changeDay(-1)}
        variant="outline"
        className="size-8 sm:size-10"
        aria-label="Previous day"
      >
        <Icon name="ChevronLeft" size="lg" />
      </Button>
      <Button
        onClick={() => changeDay(1)}
        variant="outline"
        className="size-8 sm:size-10"
        aria-label="Next day"
      >
        <Icon name="ChevronRight" size="lg" />
      </Button>
      <Stack
        className="flex-1 px-2 text-sm font-[500] sm:text-md"
        direction="horizontal"
        fullWidth={false}
        gap={1}
        wrap
        align="start"
      >
        <p className="text-nowrap">{format(date, 'eeee,')}</p>
        <p className="text-nowrap">{format(date, 'MMMM	do')}</p>
      </Stack>
      {!isToday(date) && (
        <Button
          className="h-8 px-2 sm:h-10 sm:px-4"
          variant="outline"
          onClick={() => changeDate(new Date())}
          aria-label="Today"
        >
          Today
        </Button>
      )}
    </Stack>
  );
};
